/**
 * Deposit Methods Collection
 */

define(function(require, exports, module) {
    'use strict';

    var DepositMethodModel = require('portlets/cashier/deposit/deposit.method.model');
    var CashierMethodCollection = require('portlets/cashier/cashier.method.collection');

    module.exports = CashierMethodCollection.extend({

        model: DepositMethodModel,

        paymentMethod: 'deposit'

    });

});
